require('angular');
require('./angular-scroll');

module.exports = 'duScroll';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-scroll/index.js
 ** module id = 339
 ** module chunks = 0
 **/